import Multidiffusion from '@/components/statistics/multidiffusion/Multidiffusion'
import SellerStats from '@/components/statistics/seller/SellerStats'
import RdvStats from '@/components/statistics/rdv/RdvStats'
import SaleStats from '@/components/statistics/sale/SaleStats'

export default [
  {
    path: '/statistics/multidiffusion',
    name: 'Multidiffusion',
    component: Multidiffusion,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/statistics/vendeurs',
    name: 'SellerStats',
    component: SellerStats,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/statistics/ventes',
    name: 'SaleStats',
    component: SaleStats,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/statistics/rdvs',
    name: 'RdvStats',
    component: RdvStats,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/statisticRouter.js